// extracted by mini-css-extract-plugin
export default {"container":"LinkAccordionItem_container__GOY2W","btn":"LinkAccordionItem_btn__EXQtl","links":"LinkAccordionItem_links__lChUG"};